import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../components/common/ConfirmModal/ConfirmModal';
import StudentNotesModal from '../../components/common/StudentNotesModal/StudentNotesModal';

type OrchestratorAssignmentNotesModalProps = {
  open: boolean;
  loading: boolean;
  studentName: string;
  initialNotes: string;
  onCancel: () => void;
  onSave: (notes: string) => void;
};

const OrchestratorAssignmentNotesModal: React.FC<OrchestratorAssignmentNotesModalProps> = ({
  open,
  loading,
  studentName,
  initialNotes,
  onCancel,
  onSave,
}) => {
  const [notes, setNotes] = useState(initialNotes);
  const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setNotes(initialNotes);
      setConfirmSaveOpen(false);
    }
  }, [open, initialNotes]);

  return (
    <>
      <StudentNotesModal
        open={open}
        studentName={studentName}
        notes={[]}
        showSummary={false}
        showHistory={false}
        title="Anotações"
        closeLabel="Fechar anotações"
        fieldId="orchestrator-assignment-notes"
        fieldLabel="Anotações"
        placeholder="Escreva aqui a anotação."
        width={546}
        minRows={3}
        maxRows={6}
        skipValidation
        value={notes}
        loading={loading}
        onChange={setNotes}
        onCancel={() => {
          if (!confirmSaveOpen && !loading) {
            onCancel();
          }
        }}
        onSubmit={() => setConfirmSaveOpen(true)}
      />

      <ConfirmModal
        open={confirmSaveOpen}
        variant="warning"
        icon="edit_note"
        title="Salvar anotações?"
        message="Deseja mesmo salvar esta anotação?"
        confirmLabel={loading ? 'Salvando...' : 'Salvar'}
        cancelLabel="Voltar"
        loading={loading}
        onCancel={() => {
          if (!loading) {
            setConfirmSaveOpen(false);
          }
        }}
        onConfirm={() => {
          setConfirmSaveOpen(false);
          onSave(notes.trim());
        }}
      />
    </>
  );
};

export default OrchestratorAssignmentNotesModal;
